import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

import {
    chain,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

interface Parameter {
    variantTraitId?: string;
    traitValueId?: string;
    productId: string;
}

interface Props {
    variantSelection: SafeDictionary<string>;
    variantSelectionCompleted: boolean;
    selectedProductId?: string;
    productInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;

export const WausauSetProductInfo: HandlerType = props => {
    const state = props.getState();
    const { productInfosById } = state.pages.productDetails;
    // BESUP-754
    const selectedProductId = state.pages.productDetails.selectedProductId || props.parameter.productId;

    if (!productInfosById) {
        throw new Error("productInfosById was undefined in the productDetailsState");
    }
    if (!selectedProductId) {
        throw new Error("selectedProductId was undefined in the productDetailsState");
    }

    if (!props.selectedProductId) {
        throw new Error("selectedProductId was undefined in the props for UpdateVariantSelection");
    }

    const currentProductInfo = productInfosById[selectedProductId];
    if (!currentProductInfo) {
        throw new Error(`Current. There was no productInfoById for the id ${selectedProductId}`);
    }

    let newProductInfo = productInfosById[props.selectedProductId];

    if (!newProductInfo) {
        newProductInfo = productInfosById[selectedProductId];

        if (!newProductInfo) {
            throw new Error(`New. There was no productInfoById for the id ${props.selectedProductId}`);
        }
    }

    const product = getProductState(state, props.selectedProductId).value;
    if (!product) {
        throw new Error(`There was no product found for the id ${props.selectedProductId}`);
    }

    props.productInfo = {
        ...newProductInfo,
        unitOfMeasure: product.unitOfMeasures!.some(o => o.unitOfMeasure === currentProductInfo.unitOfMeasure)
            ? currentProductInfo.unitOfMeasure
            : newProductInfo.unitOfMeasure,
        qtyOrdered: Math.max(currentProductInfo.qtyOrdered, product.minimumOrderQty),
    };
};

replaceInChain(chain, SetProductInfo, WausauSetProductInfo);
